export default __webpack_public_path__ + "static/media/step1.24f190e5.svg";